module.exports = __webpack_public_path__ + "img/close2.18fd802b.svg";